import styled from '@emotion/styled';
import ReadMore from '@portalterreno/react-ui/ReadMore';

const StyledReadMore = styled(ReadMore)(
  {
    lineHeight: '22px',
    maxWidth: 650,
    fontWeight: 300,
    fontSize: 16
  },
  ({ theme }) => ({
    color: theme.palette.colors.blackCoral
  })
);

export default StyledReadMore;
